import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private readonly renderer: Renderer2;
  private readonly globalLoadingElement: HTMLElement | null = null;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.globalLoadingElement = document.querySelector('.globalLoading');
  }

  showGlobalLoading() {
    if (this.globalLoadingElement) {
      this.renderer.removeClass(this.globalLoadingElement, 'd-none');
      this.renderer.addClass(this.globalLoadingElement, 'd-flex');
    }
  }

  hideGlobalLoading() {
    if (this.globalLoadingElement) {
      this.renderer.removeClass(this.globalLoadingElement, 'd-flex');
      this.renderer.addClass(this.globalLoadingElement, 'd-none');
    }
  }
}
